<template>
  <q-page class="bg-white">
    <q-card class="my-card" flat>
      <q-img
        src="hero-results-compressed.jpg"
        placeholder-src="hero-results-compressed-small.jpg"
        no-spinner
        alt=""
        height="250px">
        <div class="hero fit col wrap justify-center items-center content-center text-blur">

          <q-skeleton v-if="settings === null" type="text" tag="div" style="width: 50%; height: 5vh" animation="fade"></q-skeleton>
          <div v-else class="text-h1 text-center text-primary font-title">{{ eventName }}</div>

          <q-skeleton v-if="settings === null" type="text" tag="div" style="width: 30%; height: 3vh" animation="fade"></q-skeleton>
          <div v-else class="text-h5 text-center">{{ organizerName }}</div>

          <q-skeleton v-if="settings === null" type="text" tag="div" style="width: 70%; height: 3vh" animation="fade"></q-skeleton>
          <div v-else class="text-h6 text-center">Épreuve N° {{settings.number}} - {{settings.name}}</div>
        </div>
      </q-img>
    </q-card>


    <div class="q-pa-md-md q-pa-sm q-pb-xl ios-mobile">


      <div class="full-width row wrap justify-between q-mb-md bg-grey-4 q-pa-xs" style="border-radius: 20px">
        <q-btn rounded no-caps color="primary" icon="fa-solid fa-caret-left" size="sm" label="Retour" :to="{name: 'LiveRanking', params: {event_id: $route.params.event_id, number: $route.params.number}}" />
      </div>


      <div class="full-width row items-center content-center">


        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 q-mb-lg q-mt-sm">
          <div class="row content-center">

            <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2col-xl-2 separator-primary-1 q-px-md text-center">
              <span>DOSSARD</span><br />
              <q-skeleton v-if="rider === null" type="text" style="height: 5vh"></q-skeleton>
              <span v-else class="text-primary font-console text-h4 text-weight-bold">{{rider.rider.bib}}</span>
            </div>

            <div class="col-xs-6 col-sm-6 col-md-5 col-lg-5 col-xl-5 separator-primary-2 q-px-md">
              <span>CAVALIER</span><br />
              <q-skeleton v-if="rider === null" type="text" style="height: 3vh"></q-skeleton>
              <span v-else class="text-h6 text-primary">{{rider.rider.firstname.toUpperCase()}} {{rider.rider.lastname.toUpperCase()}}<br /></span>
              <q-skeleton v-if="rider === null" type="text"></q-skeleton>
              <span class="text-grey-8" v-else-if="settings && settings.federation === 'fei'"><country-flag :country="rider.rider.flag" size='normal'/></span>
              <span class="text-grey-8" v-else>{{rider.rider.club.toUpperCase()}}</span>
            </div>

            <div class="col-xs-6 col-sm-6 col-md-5 col-lg-5 col-xl-5 q-px-md">
              <span>CHEVAL</span><br />
              <q-skeleton v-if="rider === null" type="text" style="height: 3vh"></q-skeleton>
              <span v-else class="text-h6 text-primary">{{rider.horse.name}} {{rider.horse.origin ? '(' + rider.horse.origin + ')' : ''}}<br /></span>

              <q-skeleton v-if="rider === null" type="text"></q-skeleton>
              <span v-else style="font-size: 9pt" class="text-grey-8">
                {{riderHorseOrigin}}
              </span>
            </div>
          </div>
        </div>


        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" v-if="settings !== null && ['dressage', 'derby_eventing', 'cce'].includes(settings.event.type)">
          <q-markup-table flat class="table-challenge">
            <thead>
            <tr>
              <th class="text-center" v-for="n in ['% E', '% H', '% C', '% M', '% B', 'TOTAL']" :key="n" style="width: 50px">
                <q-skeleton v-if="rider === null" animation="blink" type="text" />
                <span v-else>{{n}}</span>
              </th>
            </tr>
            </thead>

            <tbody>
            <tr>
              <td class="text-center">
                <q-skeleton v-if="rider === null" animation="blink" type="text" />
                <span v-else>{{percentageLetter('e')}}</span>
              </td>

              <td class="text-center">
                <q-skeleton v-if="rider === null" animation="blink" type="text" />
                <span v-else>{{percentageLetter('h')}}</span>
              </td>

              <td class="text-center">
                <q-skeleton v-if="rider === null" animation="blink" type="text" />
                <span v-else>{{percentageLetter('c')}}</span>
              </td>

              <td class="text-center">
                <q-skeleton v-if="rider === null" animation="blink" type="text" />
                <span v-else>{{percentageLetter('m')}}</span>
              </td>

              <td class="text-center">
                <q-skeleton v-if="rider === null" animation="blink" type="text" />
                <span v-else>{{percentageLetter('b')}}</span>
              </td>

              <td class="text-center">
                <q-skeleton v-if="rider === null" animation="blink" type="text" />
                <span v-else class="text-weight-bold">{{ totalDressage }}</span>
              </td>
            </tr>
            </tbody>
          </q-markup-table>
        </div>


        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 q-mt-md q-mb-md">
          <q-card flat v-if="settings !== null && ['dressage', 'derby_eventing', 'hunter', 'cce'].includes(settings.event.type) && settings_test != null" style="height: 300px">
            <IEcharts :option="getDressageChartOptions" :resizable="true" v-if="rider_graph !== null && rider_graph_available === true" />
            <q-skeleton height="300px" class="fit column wrap text-center justify-center items-center content-center" v-else-if="rider_graph === null && rider_graph_available === true">
              <q-icon name="fa-regular fa-chart-mixed" size="xl"></q-icon>
              Génération du graphique
            </q-skeleton>
            <q-skeleton v-else height="300px" class="fit column wrap text-center justify-center items-center content-center">
              <q-icon name="fa-regular fa-chart-mixed" size="xl"></q-icon>
              Impossible de récupérer le graphique
            </q-skeleton>


          </q-card>
        </div>



        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" v-if="settings !== null && ['dressage', 'derby_eventing', 'cce'].includes(settings.event.type)">

          <q-markup-table flat class="table-challenge">
            <thead>
            <tr>
              <th class="text-left" style="width: 100px">
                <q-skeleton v-if="rider === null" animation="blink" type="text" />
                <span v-else>Figure</span>
              </th>
              <th class="text-center" v-for="n in ['E', 'H', 'C', 'M', 'B']" :key="n" style="width: 50px">
                <q-skeleton v-if="rider === null" animation="blink" type="text" />
                <span v-else>{{n}}</span>
              </th>
            </tr>
            </thead>


            <tbody v-if="rider === null || settings_test === null">
            <tr v-for="n in 10" :key="n">
              <td class="text-left" style="width: 100px">
                <q-skeleton animation="blink" type="text" />
              </td>
              <td class="text-center" v-for="p in ['E', 'H', 'C', 'M', 'B']" :key="p">
                <q-skeleton animation="blink" type="text" />
              </td>
            </tr>
            </tbody>

            <tbody v-else>


            <tr v-for="index in settings_test.definition.figures" :key='index'>
              <td class="text-left" style="width: 100px">
                <strong>Figure N°{{index}} {{ markCoef('figure', index) }}</strong><br />
                <ul style="list-style: none; padding: 0; margin: 0">
                  <li v-for="(item, key) in markMouvement('figure', index)" :key="key">
                    {{ item.letter }} {{item.texte}}
                  </li>
                </ul>
              </td>
              <td class="text-center" v-for="p in ['e', 'h', 'c', 'm', 'b']" :key="p">
                {{ markFigure(p, index - 1) }}
              </td>
            </tr>


            <tr v-for="index in settings_test.definition.ensemble" :key='index'>
              <td class="text-left" style="width: 100px; max-width: 100px; text-overflow: ellipsis; white-space: nowrap; text-wrap: pretty;">
                <strong>Note d'ensemble N°{{index}} {{ markCoef('ensemble', index) }}</strong><br />
                <ul style="list-style: none; padding: 0; margin: 0">
                  <li v-for="(item, key) in markMouvement('ensemble', index)" :key="key">
                    {{ item }}
                  </li>
                </ul>
              </td>
              <td class="text-center" v-for="p in ['e', 'h', 'c', 'm', 'b']" :key="p">
                {{ markEnsemble(p, index - 1) }}
              </td>
            </tr>


            <tr>
              <td class="text-left" style="width: 100px">
                Pénalités
              </td>
              <td class="text-center" v-for="p in ['e', 'h', 'c', 'm', 'b']" :key="p">
                {{ markPenality(p) }}
              </td>
            </tr>


            <tr v-if="settings_test !== null && settings_test.definition.bonus">
              <td class="text-left" style="width: 100px">
                Bonus
              </td>
              <td class="text-center" v-for="p in ['e', 'h', 'c', 'm', 'b']" :key="p">
                {{ markBonus(p) }}
              </td>
            </tr>


            <tr v-if="settings !== null && ['dressage'].includes(settings.event.type)">
              <td class="text-left" style="width: 100px">
                Erreurs de parcours
              </td>
              <td class="text-center" v-for="p in ['e', 'h', 'c', 'm', 'b']" :key="p">
                {{ markError(p) }}
              </td>
            </tr>

            </tbody>


          </q-markup-table>
        </div>





        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 q-mb-lg" v-if="settings !== null && ['hunter'].includes(settings.event.type)">
          <q-markup-table flat class="table-challenge">
            <thead>
            <tr>
              <th class="text-center" v-for="n in ['Juge 1', 'Juge 2', 'Juge 3', 'Juge 4', 'Juge 5', 'TOTAL']" :key="n" style="width: 50px">
                <q-skeleton v-if="rider === null" animation="blink" type="text" />
                <span v-else>{{n}}</span>
              </th>
            </tr>
            </thead>

            <tbody>
            <tr>
              <td class="text-center">
                <q-skeleton v-if="rider === null" animation="blink" type="text" />
                <span v-else>{{totalLetter('1')}}</span>
              </td>

              <td class="text-center">
                <q-skeleton v-if="rider === null" animation="blink" type="text" />
                <span v-else>{{totalLetter('2')}}</span>
              </td>

              <td class="text-center">
                <q-skeleton v-if="rider === null" animation="blink" type="text" />
                <span v-else>{{totalLetter('3')}}</span>
              </td>

              <td class="text-center">
                <q-skeleton v-if="rider === null" animation="blink" type="text" />
                <span v-else>{{totalLetter('4')}}</span>
              </td>

              <td class="text-center">
                <q-skeleton v-if="rider === null" animation="blink" type="text" />
                <span v-else>{{totalLetter('5')}}</span>
              </td>

              <td class="text-center">
                <q-skeleton v-if="rider === null" animation="blink" type="text" />
                <span v-else class="text-weight-bold">{{ totalDressage }}</span>
              </td>
            </tr>
            </tbody>
          </q-markup-table>
        </div>

        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" v-if="settings !== null && ['hunter'].includes(settings.event.type)">

          <q-markup-table flat class="table-challenge">
            <thead>
            <tr>
              <th class="text-left" style="width: 100px">
                <q-skeleton v-if="rider === null" animation="blink" type="text" />
                <span v-else>Poste</span>
              </th>
              <th class="text-center" v-for="n in ['1', '2', '3', '4', '5']" :key="n" style="width: 50px">
                <q-skeleton v-if="rider === null" animation="blink" type="text" />
                <span v-else>Juge {{n}}</span>
              </th>
            </tr>
            </thead>


            <tbody v-if="rider === null || settings_test === null">
            <tr v-for="n in 10" :key="n">
              <td class="text-left" style="width: 100px">
                <q-skeleton animation="blink" type="text" />
              </td>
              <td class="text-center" v-for="p in ['1', '2', '3', '4', '5']" :key="p">
                <q-skeleton animation="blink" type="text" />
              </td>
            </tr>
            </tbody>

            <tbody v-else>


            <tr v-for="index in settings_test.definition.postes" :key='index'>
              <td class="text-left" style="width: 100px">
                Poste N°{{index}}
              </td>
              <td class="text-center" v-for="p in ['1', '2', '3', '4', '5']" :key="p">
                {{ markFigureHunter(p, index - 1) }}
              </td>
            </tr>


            <tr>
              <td class="text-left" style="width: 100px">
                Pénalités
              </td>
              <td class="text-center" v-for="p in ['1', '2', '3', '4', '5']" :key="p">
                {{ markPenalityHunter(p) }}
              </td>
            </tr>

            </tbody>


          </q-markup-table>
        </div>

        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 q-mt-md" v-if="settings !== null && ['cso'].includes(settings.event.type)">


          <div v-for="(manche, indexManche) in settings.test.jumping.manches" :key="indexManche" class="q-mb-xl">
            <span class="text-h4 text-weight-bold">Manche N° {{indexManche + 1}}</span>

            <q-markup-table flat class="table-challenge q-mb-md">
              <thead>
              <tr>
                <th class="text-center" v-for="n in ['Pénalités à l\'obstacle', 'Temps', 'Temps de référence', 'Pénalités de temps', 'Total']" :key="n" style="width: 50px">
                  {{n}}
                </th>
                <th class="text-center" v-if="[19, 22].includes(settings.test.jumping.profil.id)" style="width: 50px">Score</th>
              </tr>
              </thead>
              <tbody>

              <tr v-if="rider !== null && [5].includes(settings.test.jumping.profil.id)" class="bg-secondary" style="height: 50px">
                <td class="text-center">{{rider.result.test.jumping.manches[indexManche].pts}} {{(rider.result.test.jumping.manches[indexManche].pts_divers > 0) ? ' (+' + rider.result.test.jumping.manches[indexManche].pts_divers + ')' : ''}}</td>
                <td class="text-center">{{rider.result.test.jumping.manches[indexManche].tps_phase_1_g}} / {{rider.result.test.jumping.manches[indexManche].tps_phase_2_g}}</td>
                <td class="text-center">{{manche.tps_phase_1_g}} / {{manche.tps_phase_2_g}}</td>
                <td class="text-center">{{rider.result.test.jumping.manches[indexManche].pts_time_phase_1}} / {{rider.result.test.jumping.manches[indexManche].pts_time_phase_2}}</td>
                <td class="text-center text-weight-bold">{{(rider.result.test.jumping.manches[indexManche].indice === null) ? rider.result.test.jumping.manches[indexManche].total : rider.result.test.jumping.manches[indexManche].indice }}</td>
              </tr>
              <tr v-else-if="rider !== null && [228].includes(settings.test.jumping.profil.id) && [1].includes(indexManche)" class="bg-secondary" style="height: 50px">
                <td class="text-center">{{rider.result.test.jumping.manches[indexManche].pts}} {{(rider.result.test.jumping.manches[indexManche].pts_divers > 0) ? ' (+' + rider.result.test.jumping.manches[indexManche].pts_divers + ')' : ''}}</td>
                <td class="text-center">{{rider.result.test.jumping.manches[indexManche].tps_phase_1_g}} / {{rider.result.test.jumping.manches[indexManche].tps_phase_2_g}}</td>
                <td class="text-center">{{manche.tps_phase_1_g}} / {{manche.tps_phase_2_g}}</td>
                <td class="text-center">{{rider.result.test.jumping.manches[indexManche].pts_time_phase_1}} / {{rider.result.test.jumping.manches[indexManche].pts_time_phase_2}}</td>
                <td class="text-center text-weight-bold">{{(rider.result.test.jumping.manches[indexManche].indice === null) ? rider.result.test.jumping.manches[indexManche].total : rider.result.test.jumping.manches[indexManche].indice }}</td>
              </tr>

              <tr v-else-if="rider !== null" class="bg-secondary" style="height: 50px">
                <td class="text-center">{{rider.result.test.jumping.manches[indexManche].pts}} {{(rider.result.test.jumping.manches[indexManche].pts_divers > 0) ? ' (+' + rider.result.test.jumping.manches[indexManche].pts_divers + ')' : ''}}</td>
                <td class="text-center">{{rider.result.test.jumping.manches[indexManche].tps_phase_g}}</td>
                <td class="text-center">{{manche.tps_phase_g}}</td>
                <td class="text-center">{{rider.result.test.jumping.manches[indexManche].pts_time}}</td>
                <td class="text-center text-weight-bold">{{(rider.result.test.jumping.manches[indexManche].indice === null) ? rider.result.test.jumping.manches[indexManche].total : rider.result.test.jumping.manches[indexManche].indice }}</td>
                <td class="text-center text-weight-bold" v-if="[19, 22].includes(settings.test.jumping.profil.id)">{{rider.result.test.jumping.manches[indexManche].score}}</td>
              </tr>
              <tr v-else style="height: 50px">
                <td><q-skeleton animation="blink" type="text" /></td>
                <td><q-skeleton animation="blink" type="text" /></td>
                <td><q-skeleton animation="blink" type="text" /></td>
                <td><q-skeleton animation="blink" type="text" /></td>
                <td><q-skeleton animation="blink" type="text" /></td>
              </tr>
              </tbody>
            </q-markup-table>


            <span class="text-h6">Rapport d'obstacles</span>
            <div v-if="manche.course && manche.course.length > 0 && rider !== null" class="q-gutter-sm">
              <q-btn
                split no-caps unelevated
                :color="getFenceColor(rider.result.test.jumping.manches[indexManche].course, fence)"
                v-for="fence in settings.test.jumping.manches[indexManche].course" :key="fence"
              >
                <div class="row items-center no-wrap">
                  <div class="text-center" style="min-width: 28px">
                    {{ fence }}<br />
                    <span v-if="rider.result.test.jumping.manches[indexManche].course && rider.result.test.jumping.manches[indexManche].course[fence] && rider.result.test.jumping.manches[indexManche].course[fence] !== ''">{{ rider.result.test.jumping.manches[indexManche].course[fence] === 'ok' ? '&nbsp;' : rider.result.test.jumping.manches[indexManche].course[fence] }}</span>
                    <span v-else>&nbsp;</span>
                  </div>
                </div>
              </q-btn>
            </div>
            <div v-else class="text-center">
              <q-icon name="fa-regular fa-chart-mixed" size="xl"></q-icon><br />
              L'organisateur n'a pas défini le détail du parcours
            </div>



          </div>

        </div>




        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 q-mt-md" v-if="settings !== null && ['cce'].includes(settings.event.type)">

          <span class="text-h4 text-weight-bold">CSO</span>
          <q-markup-table flat class="table-challenge q-mb-md">
            <thead>
            <tr>
              <th class="text-center" v-for="n in ['Pénalités à l\'obstacle', 'Temps', 'Temps de référence', 'Pénalités de temps', 'Total']" :key="n" style="width: 50px">
                {{n}}
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="rider !== null" class="bg-secondary" style="height: 50px">
              <td class="text-center">{{rider.result.test.jumping[0].pts}} {{(rider.result.test.jumping[0].pts_divers > 0) ? ' (+' + rider.result.test.jumping[0].pts_divers + ')' : ''}}</td>
              <td class="text-center">{{rider.result.test.jumping[0].time}}"</td>
              <td class="text-center">{{settings.test.jumping[0].optimal_time_g}}</td>
              <td class="text-center">{{rider.result.test.jumping[0].pts_time}}</td>
              <td class="text-center text-weight-bold">{{(rider.result.test.jumping[0].indice === null) ? rider.result.test.jumping[0].total : rider.result.test.jumping[0].indice }}</td>
            </tr>
            <tr v-else style="height: 50px">
              <td><q-skeleton animation="blink" type="text" /></td>
              <td><q-skeleton animation="blink" type="text" /></td>
              <td><q-skeleton animation="blink" type="text" /></td>
              <td><q-skeleton animation="blink" type="text" /></td>
              <td><q-skeleton animation="blink" type="text" /></td>
            </tr>
            </tbody>
          </q-markup-table>


          <span class="text-h6">Rapport d'obstacles</span>
          <div v-if="settings.test.jumping[0].course && settings.test.jumping[0].course.length > 0 && rider !== null" class="q-gutter-sm">
            <q-btn
              split no-caps unelevated
              :color="getFenceColor(rider.result.test.jumping[0].course, fence)"
              v-for="fence in settings.test.jumping[0].course" :key="fence"
            >
              <div class="row items-center no-wrap">
                <div class="text-center" style="min-width: 28px">
                  {{ fence }}<br />
                  <span v-if="rider.result.test.jumping[0].course && rider.result.test.jumping[0].course[fence] && rider.result.test.jumping[0].course[fence] !== ''">{{ rider.result.test.jumping[0].course[fence] === 'ok' ? '&nbsp;' : rider.result.test.jumping[0].course[fence] }}</span>
                  <span v-else>&nbsp;</span>
                </div>
              </div>
            </q-btn>
          </div>
          <div v-else class="text-center">
            <q-icon name="fa-regular fa-chart-mixed" size="xl"></q-icon><br />
            L'organisateur n'a pas défini le détail du parcours
          </div>


        </div>


        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 q-mt-md" v-if="settings !== null && ['derby_eventing', 'derby_cross', 'cce'].includes(settings.event.type)">

          <span class="text-h4 text-weight-bold">CROSS</span>
          <q-markup-table flat class="table-challenge q-mb-md">
            <thead>
            <tr>
              <th class="text-center" v-for="n in ['Pénalités à l\'obstacle', 'Temps', 'Temps de référence', 'Pénalités de temps', 'Total']" :key="n" style="width: 50px">
                {{n}}
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="rider !== null" class="bg-secondary" style="height: 50px">
              <td class="text-center">{{rider.result.test.eventing.pts}} {{(rider.result.test.eventing.pts_divers > 0) ? ' (+' + rider.result.test.eventing.pts_divers + ')' : ''}}</td>
              <td class="text-center">{{rider.result.test.eventing.time_g}}</td>
              <td class="text-center">{{settings.test.eventing.optimal_time_g}}</td>
              <td class="text-center">{{rider.result.test.eventing.pts_time}}</td>
              <td class="text-center text-weight-bold">{{(rider.result.test.eventing.indice === null) ? rider.result.test.eventing.total : rider.result.test.eventing.indice }}</td>
            </tr>
            <tr v-else style="height: 50px">
              <td><q-skeleton animation="blink" type="text" /></td>
              <td><q-skeleton animation="blink" type="text" /></td>
              <td><q-skeleton animation="blink" type="text" /></td>
              <td><q-skeleton animation="blink" type="text" /></td>
              <td><q-skeleton animation="blink" type="text" /></td>
            </tr>
            </tbody>
          </q-markup-table>


          <span class="text-h6">Rapport d'obstacles</span>
          <div v-if="settings.test.eventing.course && settings.test.eventing.course.length > 0 && rider !== null" class="q-gutter-sm">
            <q-btn
              split no-caps unelevated
              :color="getFenceColor(rider.result.test.eventing.course, fence)"
              v-for="fence in settings.test.eventing.course" :key="fence"
            >
              <div class="row items-center no-wrap">
                <div class="text-center" style="min-width: 28px">
                  {{ fence }}<br />
                  <span v-if="rider.result.test.eventing.course && rider.result.test.eventing.course[fence] && rider.result.test.eventing.course[fence] !== ''">{{ rider.result.test.eventing.course[fence] === 'ok' ? '&nbsp;' : rider.result.test.eventing.course[fence] }}</span>
                  <span v-else>&nbsp;</span>
                </div>
              </div>
            </q-btn>
          </div>
          <div v-else class="text-center">
            <q-icon name="fa-regular fa-chart-mixed" size="xl"></q-icon><br />
            L'organisateur n'a pas défini le détail du parcours
          </div>


        </div>

        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 q-mt-md" v-if="settings !== null && ['crossindoor'].includes(settings.event.type)">

          <span class="text-h4 text-weight-bold">CROSS INDOOR</span>
          <q-markup-table flat class="table-challenge q-mb-md">
            <thead>
            <tr>
              <th class="text-center" v-for="n in ['Pénalités à l\'obstacle', 'Temps', 'Temps de référence', 'Pénalités de temps', 'Total']" :key="n" style="width: 50px">
                {{n}}
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="rider !== null" class="bg-secondary" style="height: 50px">
              <td class="text-center">{{rider.result.test.jumping[0].pts}} {{(rider.result.test.jumping[0].pts_divers > 0) ? ' (+' + rider.result.test.jumping[0].pts_divers + ')' : ''}}</td>
              <td class="text-center">{{rider.result.test.jumping[0].time_g}}</td>
              <td class="text-center">{{settings.test.jumping[0].optimal_time_g}}</td>
              <td class="text-center">{{rider.result.test.jumping[0].pts_time}}</td>
              <td class="text-center text-weight-bold">{{(rider.result.test.jumping[0].indice === null) ? rider.result.test.jumping[0].total : rider.result.test.jumping[0].indice }}</td>
            </tr>
            <tr v-else style="height: 50px">
              <td><q-skeleton animation="blink" type="text" /></td>
              <td><q-skeleton animation="blink" type="text" /></td>
              <td><q-skeleton animation="blink" type="text" /></td>
              <td><q-skeleton animation="blink" type="text" /></td>
              <td><q-skeleton animation="blink" type="text" /></td>
            </tr>
            </tbody>
          </q-markup-table>


          <span class="text-h6">Rapport d'obstacles</span>
          <div v-if="settings.test.jumping[0].course && settings.test.jumping[0].course.length > 0 && rider !== null" class="q-gutter-sm">
            <q-btn
              split no-caps unelevated
              :color="getFenceColor(rider.result.test.jumping[0].course, fence)"
              v-for="fence in settings.test.jumping[0].course" :key="fence"
            >
              <div class="row items-center no-wrap">
                <div class="text-center" style="min-width: 28px">
                  {{ fence }}<br />
                  <span v-if="rider.result.test.jumping[0].course && rider.result.test.jumping[0].course[fence] && rider.result.test.jumping[0].course[fence] !== ''">{{ rider.result.test.jumping[0].course[fence] === 'ok' ? '&nbsp;' : rider.result.test.jumping[0].course[fence] }}</span>
                  <span v-else>&nbsp;</span>
                </div>
              </div>
            </q-btn>
          </div>
          <div v-else class="text-center">
            <q-icon name="fa-regular fa-chart-mixed" size="xl"></q-icon><br />
            L'organisateur n'a pas défini le détail du parcours
          </div>


        </div>

      </div>


    </div>
  </q-page>
</template>

<script>
import {
  parsed,
} from '@quasar/quasar-ui-qcalendar'
import { defineComponent, ref } from 'vue';
import {useMeta} from "quasar";
import IEcharts from 'vue3-echarts-v3'
import CountryFlag from "vue-country-flag-next";
import {useStore} from "vuex";

export default defineComponent({
  name: 'LiveRankingRider',
  components: {
    IEcharts,
    CountryFlag
  },
  data () {
    return {
      title: ref(this.$i18n.t('system.loading')),
      meta_description: '',
      rider: ref(null),
      rider_graph: ref(null),
      rider_graph_available: ref(true),
      settings_test: ref(null),
    }
  },
  preFetch ({ store, currentRoute, previousRoute, redirect, ssrContext, urlPath, publicPath }) {
    // fetch data, validate route and optionally redirect to some other route...
    // load timetable
    return store.dispatch("show/getSettings", {event_id: currentRoute.params.event_id, show_id: currentRoute.params.number})

    // ssrContext is available only server-side in SSR mode
  },
  computed: {
    eventName() {
      if (this.settings) {
        return this.settings.event.name
      }
      else
        return null
    },
    organizerName() {
      if (this.settings) {
        return this.settings.event.organizer.name
      }
      else
        return null
    },
    eventType() {
      if (this.settings) {
        return this.settings.event.type
      }
      else
        return null
    },
    riderHorseOrigin() {

      let str = ''

      if (this.rider === null)
        return null

      if (this.rider.horse.pere && this.rider.horse.pere.length > 0)
        str = str + this.rider.horse.pere


      if (this.rider.horse.pere && this.rider.horse.pere.length > 0 && this.rider.horse.pere_origin && this.rider.horse.pere_origin.length > 0)
        str = str + ' ('+this.rider.horse.pere_origin+')'


      if (this.rider.horse.mere && this.rider.horse.mere.length > 0) {

        if (this.rider.horse.pere.length > 0)
          str = str + ' / '

        str = str + this.rider.horse.mere


        if (this.rider.horse.mere_origin && this.rider.horse.mere_origin.length > 0)
          str = str + ' ('+this.rider.horse.mere_origin+')'


      }

      if (this.rider.horse.pere_mere && this.rider.horse.pere_mere.length > 0) {

        if (this.rider.horse.mere.length > 0)
          str = str + ' / '

        str = str + this.rider.horse.pere_mere

        if (this.rider.horse.pere_mere_origin && this.rider.horse.pere_mere_origin.length > 0)
          str = str + ' ('+this.rider.horse.pere_mere_origin+')'
      }

      return str
    },
    eventTypeLabel() {

      if (!this.settings)
        return null

      switch (this.settings.event.type) {
        case 'cce':
          return this.$i18n.t('events.type.cce')
        case 'cso':
          return this.$i18n.t('events.type.cso')
        case 'dressage':
          return this.$i18n.t('events.type.dressage')
        case 'hunter':
          return this.$i18n.t('events.type.hunter')
        case 'derby_cross':
          return this.$i18n.t('events.type.derby_cross')
        case 'derby_eventing':
          return this.$i18n.t('events.type.derby_eventing')
        case 'crossindoor':
          return this.$i18n.t('events.type.crossindoor')
        default:
          return this.settings.event.type
      }
    },
    getUserType() {
      let user = this.$store.getters["user/userGetter"]

      if (user && user.type) {
        return user.type
      }

      return null
    },
    getDressageChartOptions() {

      let data = []
      if (this.rider_graph !== null)
        data = this.rider_graph

      let base = -data.reduce(function (min, val) {
        return Math.floor(Math.min(min, val.min));
      }, Infinity);

      return {
        title: {
          text: 'Mes statistiques',
          subtext: 'Comparez vos notes avec celles des autres cavaliers de votre épreuve !',
          left: 'center',
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            animation: false,
            label: {
              backgroundColor: '#ccc',
              borderColor: '#aaa',
              borderWidth: 1,
              shadowBlur: 0,
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              color: '#222'
            }
          },
          formatter: function (params) {
            return (
              'Note N° ' + params[2].name +
              '<br />Min : ' +
              (params[0].value - base) +
              '<br />Vous : ' +
              (params[2].value - base) +
              '<br />Max : ' +
              (params[1].value + params[0].value - base)
            );
          }
        },
        xAxis: {
          type: 'category',
          data: Array.from({length: this.nbNotesGraph}, (_, i) => i + 1),
          boundaryGap: false,
          axisLabel:{
            rotate:45,
            formatter: function (value, idx) {

              if (idx === 0)
                return value

              if (this.settings && this.settings !== null) {

                if (this.settings.event.type === 'hunter')
                  return 'Poste N° ' + value
                else
                  return 'Figure N° ' + value

              }
            }.bind(this)
          }
        },
        yAxis: {
          axisPointer: {
            label: {
              formatter: function (params) {
                return (params.value - base);
              }
            }
          },
          axisLabel: {
            formatter: function (val) {
              return (val - base);
            }
          },
          splitNumber: 10
        },
        grid: {
          left: '3%',
          right: '3%',
          bottom: '3%',
          containLabel: true
        },
        series: [
          {
            name: 'max',
            type: 'line',
            data: data.map(function (item) {
              return item.min + base;
            }),
            lineStyle: {
              opacity: 0
            },
            stack: 'confidence-band',
            symbol: 'none'
          },
          {
            name: 'min',
            type: 'line',
            data: data.map(function (item) {
              return item.max - item.min
            }),
            lineStyle: {
              opacity: 0
            },
            areaStyle: {
              color: '#ccc'
            },
            stack: 'confidence-band',
            symbol: 'none'
          },
          {
            type: 'line',
            data: data.map(function (item) {
              return item.value + base;
            }),
            itemStyle: {
              color: '#121d4f'
            },
            showSymbol: false
          },
        ]
      }
    },
    totalDressage() {

      if (this.settings.event.type === 'dressage')
        return this.rider.result.test.dressage.indice ? this.rider.result.test.dressage.indice : this.rider.result.test.dressage.total_percentage + '%'
      else if (this.settings.event.type === 'derby_eventing') {

        if (this.rider.result.test.dressage.indice)
          return this.rider.result.test.dressage.indice

        return this.rider.result.test.dressage.total_percentage + '% (' + this.rider.result.test.dressage.total_pts + ')'
      }
      else if (this.settings.event.type === 'hunter') {

        if (this.rider.result.test.hunter.indice)
          return this.rider.result.test.hunter.indice

        return this.rider.result.test.hunter.total
      }
      else if (this.settings.event.type === 'cce') {

        if (this.rider.result.test.dressage.indice)
          return this.rider.result.test.dressage.indice

        return this.rider.result.test.dressage.total_percentage + '% (' + this.rider.result.test.dressage.total_pts + ')'
      }
      else
        return ''
    },
    nbNotesGraph() {

      if (this.settings.event.type === 'hunter')
        return this.settings_test.definition.postes
      else
        return this.settings_test.definition.figures + this.settings_test.definition.ensemble
    }
  },
  methods: {
    formatDate(dateInput) {
      const dateValue = parsed(dateInput + ' 00:00')
      return dateValue.day.toString().padStart(2, '0') + '/' + dateValue.month.toString().padStart(2, '0')  + '/' + dateValue.year.toString()
    },
    percentageLetter(letter) {

      if (this.rider === null)
        return '-'

      if (this.rider.result.test.dressage.indice)
        return '-'

      if (this.rider.result.test.dressage.detail[letter] !== null)
        return this.rider.result.test.dressage.detail[letter].percentage

      return '-'
    },
    totalLetter(position) {

      if (this.rider === null)
        return '-'

      if (this.rider.result.test.hunter.indice)
        return '-'

      if (this.rider.result.test.hunter.detail[position] !== null)
        return this.rider.result.test.hunter.detail[position].total

      return '-'
    },
    markFigure(letter, index) {

      if (this.rider === null)
        return '-'

      if (this.rider.result.test.dressage.detail[letter])
        return this.rider.result.test.dressage.detail[letter].figure[index]

      return '-'
    },
    markDescription(type = 'figure', index) {

      let str = ''

      if (this.settings_test === null)
        return str

      if (type === 'figure') {

        if (this.settings_test.definition.figures_details.length === 0)
          return str

        if (!this.settings_test.definition.figures_details[index - 1])
          return str

        if (this.settings_test.definition.figures_details[index - 1])
          str = this.settings_test.definition.figures_details[index - 1].summary

        if (this.settings_test.definition.figures_details[index - 1].coefficient > 1)
          str = str + ' (x' + this.settings_test.definition.figures_details[index - 1].coefficient + ')'
      }
      else if (type === 'ensemble') {

        if (this.settings_test.definition.ensemble_details.length === 0)
          return str

        if (!this.settings_test.definition.ensemble_details[index - 1])
          return str

        if (this.settings_test.definition.ensemble_details[index - 1])
          str = this.settings_test.definition.ensemble_details[index - 1].summary

        if (this.settings_test.definition.ensemble_details[index - 1].coefficient > 1)
          str = str + ' (x' + this.settings_test.definition.ensemble_details[index - 1].coefficient + ')'
      }

      return str
    },
    markCoef(type = 'figure', index) {

      let str = ''

      if (this.settings_test === null)
        return str

      if (type === 'figure') {

        if (this.settings_test.definition.figures_details.length === 0)
          return str

        if (!this.settings_test.definition.figures_details[index - 1])
          return str

        if (this.settings_test.definition.figures_details[index - 1].coefficient > 1)
          str = str + ' (coef ' + this.settings_test.definition.figures_details[index - 1].coefficient + ')'
      }
      else if (type === 'ensemble') {

        if (this.settings_test.definition.ensemble_details.length === 0)
          return str

        if (!this.settings_test.definition.ensemble_details[index - 1])
          return str

        if (this.settings_test.definition.ensemble_details[index - 1].coefficient > 1)
          str = str + ' (coef ' + this.settings_test.definition.ensemble_details[index - 1].coefficient + ')'
      }

      return str
    },
    markMouvement(type = 'figure', index) {

      let str = []

      if (this.settings_test === null)
        return str

      if (type === 'figure') {

        if (this.settings_test.definition.figures_details.length === 0)
          return str

        if (!this.settings_test.definition.figures_details[index - 1])
          return str

        if (this.settings_test.definition.figures_details[index - 1])
          str = this.settings_test.definition.figures_details[index - 1].mouvements
      }
      else if (type === 'ensemble') {

        if (this.settings_test.definition.ensemble_details.length === 0)
          return str

        if (!this.settings_test.definition.ensemble_details[index - 1])
          return str

        if (this.settings_test.definition.ensemble_details[index - 1])
          str = this.settings_test.definition.ensemble_details[index - 1].indications
      }

      return str
    },
    markEnsemble(letter, index) {

      if (this.rider === null)
        return '-'

      if (this.rider.result.test.dressage.detail[letter])
        return this.rider.result.test.dressage.detail[letter].ensemble[index]

      return '-'
    },
    markPenality(letter) {

      if (this.rider === null)
        return '-'

      if (this.rider.result.test.dressage.detail[letter])
        return this.rider.result.test.dressage.detail[letter].penal

      return '-'
    },
    markBonus(letter) {

      if (this.rider === null)
        return '-'

      if (this.rider.result.test.dressage.detail[letter])
        return this.rider.result.test.dressage.detail[letter].bonus

      return '-'
    },
    markError(letter) {

      if (this.rider === null)
        return '-'

      if (this.rider.result.test.dressage.detail[letter]) {

        if (this.rider.result.test.dressage.detail[letter].erreur !== '') {
          return this.settings_test.definition.erreur_parcours[this.rider.result.test.dressage.detail[letter].erreur]
        }
      }

      return '-'
    },
    markFigureHunter(position, index) {

      if (this.rider === null)
        return '-'

      if (this.rider.result.test.hunter.detail[position])
        return this.rider.result.test.hunter.detail[position].poste[index]

      return '-'
    },
    markPenalityHunter(position) {

      if (this.rider === null)
        return '-'

      if (this.rider.result.test.hunter.detail[position])
        return this.rider.result.test.hunter.detail[position].penal

      return '-'
    },
    getFenceColor(fence, index) {

      if (!fence)
        return 'grey'

      if (fence[index] && fence[index] === 'ok')
        return 'positive'
      if (fence[index] && fence[index] === 'joker')
        return 'positive'
      else if (['1RFR', '1RFH', '2RFR', '2RFH', 'FR', 'FH', '3RFR', '3RFH', '3RTH'].includes(fence[index]))
        return 'negative'
      else if (fence[index] && fence[index] !== '')
        return 'negative'
      else if (fence[index] && fence[index] === '')
        return 'grey'
      else return 'grey'
    },
  },
  setup () {

    const $store = useStore()
    const settings = $store.getters["show/settingsGetter"]

    return {
      settings,
    }
  },
  created: async function () {

    this.title =  'Épreuve N°' + this.settings.number + ' ' + this.settings.name + ' - ' + this.settings.event.name
    this.meta_description = 'Résultat Dossard N°' + this.$route.params.bib

    useMeta(() => {
      return {
        // whenever "title" from above changes, your meta will automatically update
        title: this.title,
        meta: {
          title: { content: this.title },
          ogTitle: { content: this.title },
          ogUrl: { content: this.$router.currentRoute._value.href },
          twitterUrl: { content: this.$router.currentRoute._value.href },
          twitterTitle: { content: this.title },
          ogDescription: { content: this.meta_description },
          twitterDescription: { content: this.meta_description },
          description: { name:'description', content: this.meta_description },
        }
      }
    })

    // get infos rider
    try {
      this.rider = await this.$store.dispatch("show/getRankingRider", {
        event_id: this.$route.params.event_id,
        show_id: this.$route.params.number,
        bib: this.$route.params.bib,
      })


      // get settings dressage / hunter
      if (['dressage', 'derby_eventing', 'hunter', 'cce'].includes(this.settings.event.type)) {

        this.settings_test = await this.$store.dispatch("show/getSettingsDressageTest", {
          event_id: this.$route.params.event_id,
          show_id: this.$route.params.number
        })

      }

      // get graph
      if (['dressage', 'derby_eventing', 'hunter', 'cce'].includes(this.settings.event.type)) {
        try {
          this.rider_graph = await this.$store.dispatch("show/getRankingRiderGraph", {
            event_id: this.$route.params.event_id,
            show_id: this.$route.params.number,
            bib: this.$route.params.bib,
          })
          this.rider_graph_available = true
        } catch (error) {
          this.rider_graph_available = false
        }
      }

    } catch (error) {
      this.$q.notify({
        textColor: 'white',
        icon: 'fa-light fa-times',
        message: "Impossible de récupérer les informations de ce cavalier"
      })
    }

  },
})
</script>

<style scoped>
.table-challenge  ::v-deep(tr):nth-child(even) {
  background-color: #f3f3f4;
}
.table-challenge ::v-deep(tr):nth-child(odd) {
  background-color: #fdfdfd;
}

.table-challenge ::v-deep(td) {
  border-color: transparent;
  height: 30px;
}

.hero .text-h5, .hero .text-h6 {
  color: #272727;
  font-weight: initial;
}

.hero {
  background: none;
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .separator-primary-1 {
    border-right: none
  }

  .separator-primary-2 {
    border-right: 1px solid var(--q-primary);
  }

  .text-h1 {
    font-size: x-large;
  }

  .text-h5 {
    font-size: medium;
  }

  .text-h6 {
    font-size: small;
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .separator-primary-1 {
    border-right: none
  }

  .separator-primary-2 {
    border-right: 1px solid var(--q-primary);
  }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .separator-primary-1 {
    border-right: none
  }

  .separator-primary-2 {
    border-right: 1px solid var(--q-primary);
  }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .separator-primary-1, .separator-primary-2 {
    border-right: 1px solid var(--q-primary);
  }
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .separator-primary-1, .separator-primary-2 {
    border-right: 1px solid var(--q-primary);
  }
}
</style>


